module.exports = __webpack_public_path__ + "static/llama-bg-01-fea91429c6c73799a9136aef78b6ffea.png";